import { NgModule } from '@angular/core';
import { OrderBy } from './order-by.pipe';

@NgModule({
    declarations: [OrderBy],
    exports: [OrderBy]
})
export class OrderByModule { }